'use client';

const PRINCIPLES = [
  {
    num: 'I.',
    title: 'La Sélection',
    text: "Cuirs pleine fleur tannés végétal, sélectionnés à la main chez les meilleurs mégissiers d'Europe et d'Afrique. Chaque peau est inspectée, massée, écoutée. Seules les plus nobles entrent à l'atelier.",
  },
  {
    num: 'II.',
    title: 'Le Geste',
    text: "Coupe au scalpel, couture sellier à la main au fil de lin ciré, pose de hardware doré à l'ancienne. Aucune machine n'imite ce que la main de l'artisan sait faire mieux : sentir la matière.",
  },
  {
    num: 'III.',
    title: 'La Patine',
    text: "Chaque pièce reçoit sept couches de cire d'abeille teintée, polies à la brosse de chèvre jusqu'à obtenir cette profondeur de teinte unique qui s'embellira pendant des décennies.",
  },
];

export default function Craft() {
  return (
    <section
      id="art"
      className="relative py-24 sm:py-32 overflow-hidden bg-[#0a0a0f] border-t border-[#D4AF37]/10"
    >
      {/* Background image — atelier */}
      <div className="absolute inset-0">
        <img
          src="/images/atelier.png"
          alt="Mains d'artisan cousant le cuir"
          className="w-full h-full object-cover"
          style={{ filter: 'brightness(0.32) saturate(1.15)' }}
        />
        <div
          className="absolute inset-0"
          style={{
            background:
              'linear-gradient(180deg, rgba(10,10,15,0.85) 0%, rgba(10,10,15,0.55) 50%, rgba(10,10,15,0.92) 100%)',
          }}
        />
      </div>

      <div className="relative max-w-6xl mx-auto px-5 sm:px-8">
        {/* Header */}
        <div className="text-center mb-20">
          <div className="flex items-center justify-center gap-3 mb-4">
            <span className="block h-px w-10 bg-[#D4AF37]" />
            <span className="eyebrow">L'Art du Cuir</span>
            <span className="block h-px w-10 bg-[#D4AF37]" />
          </div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight mb-5">
            <span className="text-[#F4E8C1]">Trois temps,</span>{' '}
            <span className="text-gold-gradient">trois sacrements.</span>
          </h2>
          <p className="max-w-2xl mx-auto text-[#F4E8C1]/70 font-serif italic text-lg leading-relaxed">
            « Le cuir est une matière vivante. On ne le fabrique pas, on
            l'accompagne. »
          </p>
        </div>

        {/* Principles */}
        <div className="grid md:grid-cols-3 gap-8 lg:gap-12">
          {PRINCIPLES.map((p) => (
            <div
              key={p.num}
              className="relative bg-[#12121a]/70 backdrop-blur-sm border border-[#D4AF37]/20 p-8 hover:border-[#D4AF37]/50 transition-colors duration-500"
            >
              {/* Roman numeral */}
              <div className="font-display text-5xl font-bold text-gold-gradient mb-4 opacity-90">
                {p.num}
              </div>
              <h3 className="font-display text-xl font-semibold text-[#F4E8C1] mb-3 tracking-wide">
                {p.title}
              </h3>
              <p className="text-sm text-[#F4E8C1]/65 leading-relaxed font-light">
                {p.text}
              </p>

              {/* Decorative bottom */}
              <div className="mt-6 h-px bg-gradient-to-r from-[#D4AF37]/40 to-transparent" />
            </div>
          ))}
        </div>

        {/* Process quote */}
        <div className="mt-20 text-center max-w-3xl mx-auto">
          <p className="font-serif italic text-xl sm:text-2xl text-[#F4E8C1]/85 leading-relaxed">
            « Trente-six heures de travail pour un sac. Quarante-huit pour une
            veste. Le temps n'est pas notre ennemi : c'est notre plus fidèle
            allié. »
          </p>
          <p className="mt-5 text-xs uppercase tracking-[0.3em] text-[#D4AF37]">
            — S.E. MATAR
          </p>
        </div>
      </div>
    </section>
  );
}
